var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrackman1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5781 0.971161H68.3662V10.9002H70.5781V0.971161Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2603 0.971161L32.8761 10.9002H35.3896L36.5458 9.03561H44.1364L45.2926 10.9002H47.8061L41.5727 0.971161H39.2603ZM37.7522 7.21762L40.4165 3.06885L43.0808 7.21762H37.7522Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2406 0.971161H78.4704L70.6284 5.91239L78.4704 10.9002H82.2406L74.3986 5.91239L82.2406 0.971161Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.438 0.971161L94.8581 8.42961L89.2783 0.971161H86.4129V10.9002H88.6248V3.62823L94.0538 10.9002H95.6625L101.092 3.62823V10.9002H103.303V0.971161H100.438Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.939 10.9002L111.145 9.03561H118.736L119.943 10.9002H122.456L116.122 0.971161H113.81L107.476 10.9002H109.939ZM114.916 3.06885L117.53 7.21762H112.251L114.916 3.06885Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.788 0.971161V8.56946L129.293 0.971161H126.528V10.9002H128.74V3.30193L137.285 10.9002H140V0.971161H137.788Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9695 0.971161H0V2.78916H5.0772V10.9002H7.28905V2.78916H11.8133L12.9695 0.971161Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5296 7.87023C61.2783 8.56946 60.5745 9.08223 59.7702 9.08223H54.9946C54.14 9.08223 53.386 8.56946 53.1849 7.68377C52.9838 6.47177 52.9336 5.30639 53.1849 4.18762C53.386 3.30193 54.0898 2.74254 54.9946 2.74254C55.8995 2.74254 59.7702 2.74254 59.7702 2.74254C60.5745 2.74254 61.3285 3.25531 61.5296 3.95454L63.3896 2.78916C62.8366 1.81024 61.7307 0.971161 60.0718 0.971161H54.5925C52.7828 0.971161 51.526 2.13654 51.1239 3.44177C50.6714 4.79362 50.7217 7.12438 51.1239 8.383C51.5763 9.73484 52.7828 10.8536 54.6427 10.8536H60.1221C61.781 10.8536 62.8869 9.96792 63.4399 8.989L61.5296 7.87023Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4075 4.37409C29.4075 2.41625 27.8995 1.01779 26.0395 1.01779H17.0916V10.9002H19.3034V7.68378H24.833L26.8438 10.9002H29.3573L27.1957 7.49732C28.5027 7.03117 29.4075 5.81917 29.4075 4.37409ZM25.7379 5.9124H19.3034V2.74256H25.7379C26.6427 2.74256 27.3968 3.44179 27.3968 4.32748C27.3968 5.25978 26.6427 5.9124 25.7379 5.9124Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrackman1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Trackman1.3237e6626e42d61c87703cebedffa951.svg";